import React from 'react';

const accountSettings = {
  title: 'Account Settings',
  items: [
    {
      header: 'How do I create an account?',
      content: (
        <div>
          <p>You can easily create an account by clicking ‘Sign Up’.</p>
        </div>
      )
    },
    {
      header: 'How can I change my email address?',
      content: (
        <div>
          <p>You cannot change your registered email by yourself as it is used to log in to your account. </p>
          <p>If you would like to do so, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
        </div>
      )
    },
    {
      header: 'Who is a Local Expert?',
      content: (
        <div>
          <p>You can’t discover the secrets of Thailand without a local to lead your way! That’s why TakeMeTour seeks Local Experts to help you do this. Each Local Expert undergoes a rigorous background check, so you can feel comfortable and safe throughout your tour.</p>
          <p>Local Experts know Thailand well, and with their knowledge and expertise, you’ll get a local experience unlike any other in Thailand. Whether it’s cooking an authentic Thai meal at a local’s home or conversing with Buddhist monks at the door of a stunning temple, you can get involved in the local culture in a very unique way.</p>
        </div>
      )
    },
    {
      header: 'How do I know that TakeMeTour is safer than others?',
      content: (
        <div>
          <p>Because your safety is our priority, TakeMeTour strictly applies our Local Expert screening procedure. To become a part of our Local Expert team, each Local Expert candidate is required to undergo a rigorous background check. This includes submitting information and uploading ID card, phone number, bank book, and criminal record check. You can rest assured and feel safe throughout your tour.</p>
          <p>Once you complete the payment with our world-class platform, the trip fee will be held by the system and transferred to your Local Expert after the trip day. TakeMeTour makes sure that you are 100% satisfied with your experience before we transfer the trip fee to the Local Expert.</p>
        </div>
      )
    },
    {
      header: 'How can I reset my password? ',
      content: (
        <div>
          <p>To reset your password, visit ‘Edit Your Profile’ then select ‘Settings’ to change your password. </p>
        </div>
      )
    },
    {
      header: 'What can I do if I forgot my password?',
      content: (
        <div>
          <p>Click ‘forgot your password’. A password reset email will be sent to your registered email immediately and you can change your password.</p>
          <p>If you still have difficulty logging in to your account, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com.</a> We will do our best to help you.</p>
        </div>
      )
    },
    {
      header: 'How can I deactivate my account? ',
      content: (
        <div>
          <p>Referring to our <a href="../../static/files/help-center/TakeMeTour Privacy Policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy and Terms of Use</a>, you can deactivate your account by <a href="../../static/files/help-center/GENERAL CONSENT WITHDRAWAL & DEACTIVATED ACCOUNT REQUEST FORM.pdf" target="_blank" rel="noopener noreferrer">submitting</a> this form and sending it to us at <a href="mailto:support@takemetour.com">support@takemetour.com.</a> Your account will be permanently deleted within 30 business days. </p>
        </div>
      )
    },
  ]
};

export default accountSettings;
